export const Dictionary = {
    /** パスワードポリシー */
    SecurityPwdPolicy: {
        1: '半角英数記号混合',
        2: '半角英数混合',
    },
    /** パスワード変更催促までの期間 */
    SecurityPwdExpire: {
        0: 'なし',
        1: '30日',
        2: '60日',
        3: '90日',
    },
    /** 現況把握回答種別 */
    CurrentStatus: {
        1: '自分で問題なく対処できている',
        2: '周囲からの援助や相談をすることで対処できている',
        3: '専門機関（医療機関やその他相談機関）を受診中または受診予定',
        4: 'カウンセラーに相談したい',
    },
    /** 利用数タイトル */
    Vol: {
        VolIni: '初回利用人数',
        VolF2f: '対面',
        VolTelRsv: '電話(予約)',
        VolTelImd: '電話(即時)',
        VolOnline: 'オンライン',
        VolSns: 'SNS相談',
        VolWeb: 'Webメール相談スレッド起票数',
        VolWebSnd: 'Webメール相談送信数',
        VolWebRcv: 'Webメール相談受信数',
    },
    /** 性別 */
    GrpGender: {
        1: '男性',
        2: '女性',
        3: '未回答',
        null: '不明',
    },
    /** 年齢別 */
    GrpAgeType: {
        1: '25歳以下',
        2: '26～30歳',
        3: '31～35歳',
        4: '36～40歳',
        5: '41～45歳',
        6: '46～50歳',
        7: '51～55歳',
        8: '56～60歳',
        9: '61～65歳',
        A: '66～70歳',
        B: '71歳以上',
        null: '不明',
    },
    /** 勤続年数種別 */
    GrpSvcLenType: {
        1: '6ヶ月以内',
        2: '7ヶ月～1年',
        3: '2年～3年',
        4: '4年～5年',
        5: '6年～10年',
        6: '11年～15年',
        7: '16年～20年',
        8: '21年～25年',
        9: '26年～30年',
        10: '31年～35年',
        11: '36年～40年',
        12: '41年以上',
        null: '不明',
    },
    /** セッショングループステータス */
    SessionGrpStatus: {
        1: '受付',
        2: '継続',
        3: '中断',
        4: '終結',
        5: 'キャンセル',
    },
    /** 利用方法 */
    CngMethodType: {
        1: '対面',
        2: '電話',
        3: 'オンライン',
    },
    /** 開示カウンセリング詳細モーダルの、報告書一覧の表のステータス */
    DisclosuerCounselingDetailReportReservationStatus: {
        1: '受付',
        2: '確定',
        3: 'キャンセル',
        4: '当日キャンセル',
    },
};
